import { Controller } from 'stimulus';
const POSTAL_CODE_API =
  'https://api.drtlgi.com/location-gateway/postal-codes/?postal_codes=';

class ZipValidationController extends Controller {
  static targets = ['container', 'input', 'helper'];

  connect() {
    this.cleanUp = this._cleanUp.bind(this);
    this.listener = this._listener.bind(this);

    if (this.inputTargets.length) {
      this.inputTarget.addEventListener('blur', this.listener);
      window.addEventListener('focus-controller-blur', this.cleanUp);
      this._initForm();
    }
  }

  async _listener() {
    const zip = this.inputTarget.value;
    const location = await this._fetch(zip);

    if (location) {
      this._setSuccess(location);
    } else {
      this._setError();
    }
  }

  async _fetch(zip) {
    let query = zip;

    if (!zip || zip === '') {
      query = '0';
    }

    const res = await fetch(`${POSTAL_CODE_API}${query}`);
    const [location] = await res.json();

    return location;
  }

  // to be ran if element is a part of a form
  // catches submit without blur
  _initForm() {
    const form = this.inputTarget.closest('form');

    form?.addEventListener('submit', this.listener);
  }

  _setSuccess(location) {
    this._cleanUp();
    this.containerTarget.insertAdjacentHTML(
      'beforeend',
      `<div data-target="zip-validation.helper" class="gzl-FormField-help" data-testid="zip-validation-helper">That's ${location.city}, ${location.region}</div>`
    );
  }

  _setError() {
    this._cleanUp();
    this.containerTarget.classList.add('is-invalid');
    this.inputTarget.setCustomValidity('Please enter a valid ZIP code.');
    this.containerTarget.insertAdjacentHTML(
      'beforeend',
      '<p data-target="zip-validation.helper" class="gzl-FormField-error" data-testid="zip-validation-helper">Please enter a valid ZIP code.</div>'
    );
  }

  _cleanUp() {
    this.containerTarget.classList.remove('is-invalid');
    this.inputTarget.setCustomValidity('');
    this.helperTargets.forEach((elem) => elem.remove());
  }
}

export default ZipValidationController;
